import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { UnitMeasurement } from "../../../../../types/unitMeasurement";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditUnit: (id: number) => void;
  onDeleteUnit: (id: number) => void;
  onViewUnit: (id: number) => void;
  data: UnitMeasurement[];
  [x: string]: any;
}
export default function DataTable({
  onEditUnit,
  onDeleteUnit,
  onViewUnit,
  data,
  userValidation,
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Unit Of Measurement - Maintenance") ||
            hasClaim("Unit Of Measurement - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_PRIORIDADE}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewUnit(row.ID_UM)}
        color="inherit"
        data-testid="view-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Unit Of Measurement - Maintenance")
            ? "block"
            : "none",
        }}
        key={`edit-${row.ID_UM}`}
        icon={<EditIcon />}
        label="Edit"
        className="textPrimary"
        onClick={() => onEditUnit(row.ID_UM)}
        color="inherit"
        data-testid="edit-button"
      />,
      <GridActionsCellItem
        sx={{
          display: hasClaim("Unit Of Measurement - Maintenance")
            ? "block"
            : "none",
        }}
        key={`delete-${row.ID_UM}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteUnit(row.ID_UM)}
        color="inherit"
        data-testid="delete-button"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "SIGLADESCRICAO",
      headerName: "Unif Of Measurement",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <span>
          {params.row.SIGLA} - {params.row.DESCRICAO}
        </span>
      ),
    },
    {
      field: "ATIVO",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data?.map((row) => row.ID_UM)}
        data-testid="unit-data-table"
        data={data}
        columns={columns}
        {...props}
      />
    </>
  );
}
